<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

    <module-content *ngIf="!isLoading && !is401 && !is404" title="{{ 'feedback'|translate }}">
      <div class="search-bar">
        <mat-form-field color="primary" class="">
            <input matInput
                   type="text"
                   maxlength="255"
                   placeholder="{{ 'Filter' | translate }}"
                   #filterInput
                   (keyup)="onFilterKeyup(filterInput.value)">
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort>
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Name' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div *ngIf="row.rights.view; else notLink">
                        <a [routerLink]="'/' + organization.code + '/app/athletes/' + athleteUser.id + '/feedback/' + row.id">{{ row.sessionName || row.name }}</a>
                    </div>
                    <ng-template #notLink>
                        <div>{{ row.sessionName || row.name }}</div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createDate">
                <mat-header-cell *matHeaderCellDef class="created-at-cell">{{ 'CreatedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="created-at-cell">
                    <div>{{ row.createDate|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="mood">
                <mat-header-cell *matHeaderCellDef class="mood-cell"><!--{{ 'Mood' | translate }}--></mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="mood-cell">
                    <div>
                        <app-feedback-athlete-smiley
                            *ngIf="row.mood"
                            [organization]="organization"
                            [athlete]="athleteUser.athlete!"
                            [mood]="row.mood"
                            [defaultClass]="moodIconClass"
                        ></app-feedback-athlete-smiley>
                    </div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right"></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row;  let i = index" class="cell-right">
                    <button  *ngIf="row.rights.edit || row.rights.delete"
                             mat-icon-button
                             [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button
                            [disabled]="!row.rights.delete"
                            mat-menu-item
                            (click)="onDeleteClicked(row)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
        <mat-paginator #paginator
                       [class.hidden]="dataSource.count == 0"
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons
                       [pageSize]="pageSize"
                       [length]="totalSize"
                       [pageIndex]="currentPage"
                       (page)="onPaginateChange($event)"
        >
        </mat-paginator>

        <div fxLayout="row" fxLayoutAlign="space-evenly center" class="mb-40" *ngIf="dataSource.count == 0">
            <p>{{ 'NoFeedbackAtTheMoment'|translate }}</p>
        </div>
    </module-content>
</mobile-page-content>
